/**
 * Utility functions for Git operations
 */

/**
 * Gets the current Git commit hash for use as Sentry release identifier
 * @returns The current Git commit hash or a fallback identifier
 */
export function getGitCommitHash(): string {
  // In the browser environment, we need to get this from build-time
  // The actual Git command execution happens at build time in vite.config.ts
  // Here we use the environment variable that should be set during build
  return import.meta.env.VITE_SENTRY_RELEASE || 'unknown-release';
}

/**
 * Gets a short version of the Git commit hash (first 7 characters)
 * @returns Short Git commit hash
 */
export function getShortGitCommitHash(): string {
  const fullHash = getGitCommitHash();
  return fullHash.startsWith('build-') ? fullHash : fullHash.substring(0, 7);
}